import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { submitScheduleSpecialDebit } from '../../../actions/profileActions';
import './SpecialDebitButton.css';

class SpecialDebitButton extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            isTop: true,
        }
        this.componentDidMount = this.componentDidMount.bind(this);
        this.ScheduleSpecialDebit = this.ScheduleSpecialDebit.bind(this);
    }

    componentDidMount() {
        document.addEventListener('scroll', (event: any) => {
            const isTop = window.scrollY < 100;

            if (isTop !== this.state.isTop) {
                this.setState({ isTop });
            }
        });
    }

    async ScheduleSpecialDebit() {
        await this.props.dispatchRaiseSpecialDebit(this.props.profile.scheduledSpecialDebitDate);
    }

    public render() {

        return (
            <>
                <div id="AcceptQuote-sidebar" className='visible'>
                    <div id="AcceptQuote-container">
                        <div className="row">
                            <div className="col-12 col-lg-9 pr-lg-0 padding">
                                <p className="stickySchedule" onClick={() => this.ScheduleSpecialDebit()}>Schedule special debit</p>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchRaiseSpecialDebit: (selectedSpecialDebitDate) => dispatch(submitScheduleSpecialDebit(selectedSpecialDebitDate)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SpecialDebitButton);